import { RESET_FORM, SET_FORM, SEND_FORM, FORM_ERROR } from '../actions/types';

const INITIAL_STATE = { error: '', form : {}, message: '', reset : null };

export default function (state = INITIAL_STATE, action) {
  switch (action.type) {
    case RESET_FORM:
      return { ...state, form : {}, error: '', message: '', reset : true };
    case SET_FORM:
      return { ...state, form : {...state.form,...action.payload}, error: '', message: 'set', reset : false };
    case SEND_FORM:
      return { ...state, error: '', message: action.payload.message };
    case FORM_ERROR:
      return { ...state, error: action.payload, message:'' };
  }

  return state;
}



// WEBPACK FOOTER //
// ./src/client/reducers/form_reducer.js